export const ORDER_CART_TEST_ID = {
    ORDER_CART: 'order-cart',
    HEADER: 'order-cart-header',
    TOTALS: 'order-cart-totals',
    PREORDER_BANNER: 'order-cart-preorder-banner',
    OUT_OF_STOCK: 'order-cart-out-of-stock',
    VALUE_PROMPTS: 'order-cart-value-prompts',
    VAT_NOTE: 'order-cart-vat-note',
    LEGAL_TEXT: 'order-cart-legal-text',
    ACTION: 'order-cart-action',
    SECONDARY_ACTION: 'order-cart-secondary-action',
    PRICE: 'cart-price-tag',
    ENTRY_ACTION: 'cart-entry-action',
    TOTALS_NOTIFICATION: 'order-cart-totals-notification',
    PRICE_TOTAL_MONTHLY: 'order-cart-price-total-monthly',
    PRICE_TOTAL: 'order-cart-price-total',
    FUTURE_PRICE: 'order-cart-future-price',
    PRICE_FUTURE_TOTAL: 'order-cart-future-total-price',
    DISNEY_VAS_PRICE: 'order-cart-price-disney',
    HBO_MAX_VAS_PRICE: 'order-cart-price-hbo-max',
    NETFLIX_VAS_PRICE: 'order-cart-price-netflix',
    PRICE_DELIVERY: 'order-cart-price-delivery',
    PRICE_GIFT: 'order-cart-price-gift',
    PRICE_GIFT_COPYRIGHT_FEE: 'order-cart-price-gift-copyright-fee',
    PRICE_INSURANCE: 'order-cart-price-insurance',
    PRICE_MAIN_PRODUCT_MONTHLY: 'order-cart-price-main-product-monthly',
    PRICE_MAIN_PRODUCT_TOTAL: 'order-cart-price-main-product-total',
    PRICE_MAIN_PRODUCT_RESIDUAL: 'order-cart-price-main-product-residual',
    PRICE_MAIN_PRODUCT_INITIAL: 'order-cart-price-main-product-initial',
    PRICE_MAIN_PRODUCT_COPYRIGHT_FEE: 'order-cart-price-main-product-copyright-fee',
    PRICE_MAIN_PRODUCT_DISCOUNT: 'order-cart-price-main-product-discount',
    PRICE_RATE_PLAN: 'order-cart-price-rate-plan',
    PRICE_PROMOTION: 'order-cart-price-promotion',
    PRICE_SERVICE: 'order-cart-price-service',
    PRICE_SIM_CARD: 'order-cart-price-sim-card',
    PRICE_UPSELL: 'order-cart-price-upsell',
    PRICE_UPSELL_COPYRIGHT_FEE: 'order-cart-price-upsell-copyright-fee',
    ENTRY_TITLE_MAIN_PRODUCT: 'order-cart-entry-title-main-product',
    ENTRY_TITLE_GIFT: 'order-cart-entry-title-gift',
    ENTRY_TITLE_UPSELL: 'order-cart-entry-title-upsell',
    ENTRY_TITLE_SIM_CARD: 'order-cart-entry-title-sim-card',
    ENTRY_TITLE_SERVICE: 'order-cart-entry-title-service',
    ENTRY_TITLE_PROMOTION: 'order-cart-entry-title-promotion',
    ENTRY_TITLE_NETFLIX: 'order-cart-entry-title-netflix',
    ENTRY_TITLE_RATE_PLAN: 'order-cart-entry-title-rate-plan',
    ENTRY_TITLE_INSURANCE: 'order-cart-entry-title-insurance',
    ENTRY_TITLE_DELIVERY: 'order-cart-entry-title-delivery',
};

export const ORDER_CART_ENTRY_ID = {
    DELIVERY: 'delivery-entry',
    DISCOUNT: 'discount-entry',
    GIFT: 'gift-entry',
    INSURANCE: 'insurance-entry',
    MAIN_PRODUCT: 'main-product-entry',
    MOB_RATE_PLAN: 'mob-rate-plan-entry',
    NETFLIX_VAS: 'netflix-value-added-service-entry',
    DISNEY_VAS: 'disney-value-added-service-entry',
    HBO_MAX_VAS: 'hbo-max-value-added-service-entry',
    PROMOTION: 'promotion-entry',
    SERVICE: 'service-entry',
    SIM_CARD: 'sim-card-entry',
    UPSELL: 'upsell-entry',
    TV_PLAN: 'tv-plan-entry',
};

const ID_BASE = 'order-cart';
export const ID = {
    MAIN: ID_BASE,
    HEADING: ID_BASE + '--heading',
    HEADING_EXPAND_BTN: ID_BASE + '--heading-expand-btn',
    ENTRIES_LIST: ID_BASE + '--entries-list',
};

export const HEADER_EXPANDED_STATE_KEY = 'order-cart-header-expanded';
